/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { editSubscribe } from '../../apis/admin/newsletter';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import Form from '../Form';
import Modal, { ModalHeader } from '../Modal';

const defaultForm = {
  name: "",
  email: "",
};

const Newsletter = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  useEffect(() => {
    setFields([
      {
        title: "구독자명",
        key: "name",
        type: "input",
        required: true,
      },
      {
        title: "이메일",
        key: "email",
        type: "input",
        required: true,
      },
    ]);
  }, [mode]);

  const _submit = (form) => {
    if (mode === "detail") {
      systemAlert(`"${form.name}"의 구독자 정보를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              editSubscribe({ name: form.name, email: form.email }, form.idx)
                .then(res => {
                  cancel();
                  submit && submit();
                })
                .catch(err => {
                  console.error(err.response);
                })
                .finally(() => {

                });

            }
          }
        ]
      });

    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>
          {selectedItem &&
            <>"{selectedItem.name}"
            </>} 구독자 정보 {mode === "create" ? "신규 등록" : "수정"}
        </ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '등록' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>

    </Modal>
  );
};

export default Newsletter;